import {
  Avatar,
  Center,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Wrap,
  WrapItem
} from '@chakra-ui/react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import tw from 'twin.macro';

import { useAuthContext } from '../../providers/AuthContextProvider';
import Logo from '../icons/Logo';

const NavbarElement = styled.div`
  ${tw`bg-primary text-white flex p-3 gap-2 items-center`}
`;

const Navigation = styled.div`
  ${tw`flex justify-between flex-1`}

  a {
    ${tw`border-b-2 border-b-transparent`}

    &.active {
      ${tw`border-b-neutral-1000`}
    }
  }
`;

const navItemHeight = '48px';
const navItemSpacing = '24px';

export function Navbar() {
  const { user, logout } = useAuthContext();
  const { firstName, lastName, email } = user || {};

  return (
    <NavbarElement>
      <Navigation>
        <Wrap align={'center'} spacing={navItemSpacing}>
          <WrapItem>
            <Center h={navItemHeight}>
              <Link to="/">
                <HStack>
                  <Logo />
                  <p className="text-lg font-bold">needle</p>
                </HStack>
              </Link>
            </Center>
          </WrapItem>
        </Wrap>
        {user && (
          <Wrap align={'center'} spacing={navItemSpacing}>
            <WrapItem>
              <Center h={navItemHeight}>{email}</Center>
            </WrapItem>
            <WrapItem>
              <Menu>
                <Center h={navItemHeight}>
                  <MenuButton
                    as={Avatar}
                    name={firstName || lastName ? `${firstName} ${lastName}` : undefined}
                  />
                </Center>
                <MenuList color={'black'}>
                  <MenuItem onClick={logout}>Logout</MenuItem>
                </MenuList>
              </Menu>
            </WrapItem>
          </Wrap>
        )}
      </Navigation>
    </NavbarElement>
  );
}

export default Navbar;
